"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormRichSelectContext", {
    enumerable: true,
    get: function() {
        return FormRichSelectContext;
    }
});
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const FormRichSelectContext = _react.default.createContext({
    floating: ()=>undefined,
    middlewareData: {},
    placement: "bottom-start",
    reference: ()=>undefined,
    refs: {
        floating: {
            current: null
        },
        reference: {
            current: null
        }
    },
    setOpen: ()=>undefined,
    open: false,
    strategy: "absolute",
    update: ()=>undefined,
    x: null,
    y: null,
    disabled: false
});

//# sourceMappingURL=FormRichSelectContext.js.map